import { z } from 'zod';
/**
 * Delete Process Connection Response Schema
 * DELETE /api/v2/process/connections/:id
 */ export const DeleteProcessConnectionResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-process-connection.schema.js.map